// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3wtXX","choiceBoxes":"toolbarselects_choiceBoxes__zKex_","simpleField":"toolbarselects_simpleField__1MUjH"};